import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";

export default function Footer() {
  return (
    <footer className="bg-brand-indigoDark text-[#C7D2FE]" data-testid="site-footer">
      <div className="mx-auto max-w-6xl px-6 py-12">
        <div className="flex flex-col gap-8 md:flex-row md:items-center md:justify-between">
          <div>
            <Logo variant="light" size={28} />
            <p className="mt-4 max-w-sm text-[14px] text-[#A5B4FC]">
              Tu secretaria virtual para pymes y autónomos. Sin oficina, sin nóminas,
              sin contratos de permanencia.
            </p>
          </div>
          <div className="flex flex-wrap gap-6 text-[13.5px]">
            <Link to="/aviso-legal" data-testid="footer-aviso-legal" className="hover:text-white transition-colors">
              Aviso legal
            </Link>
            <Link to="/privacidad" data-testid="footer-privacidad" className="hover:text-white transition-colors">
              Privacidad
            </Link>
            <Link to="/cookies" data-testid="footer-cookies" className="hover:text-white transition-colors">
              Cookies
            </Link>
            <Link to="/login" data-testid="footer-admin" className="text-[#7A83C7] hover:text-white transition-colors">
              Acceso
            </Link>
          </div>
        </div>
        <div className="mt-10 border-t border-white/10 pt-6 text-[13px] text-[#A5B4FC]">
          © {new Date().getFullYear()} asistentesvirtual.com — Todos los derechos reservados.
        </div>
      </div>
    </footer>
  );
}
